import React, { forwardRef } from 'react';
import cn from 'classnames';
import styles from './styles.module.css';
export const Icon = forwardRef(({ className, ...rest }, ref) => {
    return React.createElement("svg", { ref: ref, className: cn(styles.icon, className), ...rest });
});
